export default "__VITE_ASSET__DulSLYj$__"